import 'react-quill-new/dist/quill.snow.css'
import './styles.css'

import { CssBaseline, ThemeProvider } from '@mui/material'

import { ThemeContextProvider, useTheme } from './contexts'
import Routes from './Routes'

function AppContent() {
  const { theme } = useTheme()

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Routes />
    </ThemeProvider>
  )
}

function App() {
  return (
    <ThemeContextProvider>
      <AppContent />
    </ThemeContextProvider>
  )
}

export default App
